import { createFileRoute } from '@tanstack/react-router'
import { fetchDevices } from '../../admin/server-fns'
import {
  SAMPLE_LIMIT,
  SampleNote,
  VersionDistribution,
  groupDevices,
} from '../../admin/aggregate'
import { AdminRouteError, PageHeader } from '../../admin/ui'

export const Route = createFileRoute('/admin/firmware')({
  loader: async () => fetchDevices({ data: { page: 1, limit: SAMPLE_LIMIT } }),
  component: Firmware,
  errorComponent: AdminRouteError,
})

function Firmware() {
  const data = Route.useLoaderData()
  const groups = groupDevices(data.items, (d) => d.firmwareVersion)

  return (
    <>
      <PageHeader kicker="Operations" title="Firmware" />
      <p className="mb-4 mt-0 max-w-xl text-sm text-slate-600 dark:text-slate-400">
        Firmware versions currently reported across the fleet.
      </p>
      <SampleNote total={data.total} sampled={data.items.length} />
      <VersionDistribution
        label="Firmware version"
        groups={groups}
        total={data.items.length}
      />
    </>
  )
}
